import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { AvForm, AvGroup, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../i18next';

import {
    setManualDbScaling,
    getCurrentDbCapacity,
    getAllScheduledSettings,
    deleteScheduledSetting,
    createUpdateScheduledSetting,
    canUserAccessPosSettings,
    canUserAccessPauseAllRestaurants,
    resetUserAccessPauseAllRestaurants,
    dispatchErrorMessage
} from '../../../actions';
import ScalingCapacityScreen from './ScalingCapacityScreen';
import ScheduledSettingsScreen from './ScheduledSettingsScreen';
import PasswordVerificationScreen from '../../common/PasswordVerificationScreen';
import SettingsContentSection from '../../common/SettingsContentSection';
import ConfirmationModal from '../../common/ConfirmationModal';
import ModalContent from './common/ModalContent';
class DatabaseContainer extends Component {
    constructor() {
        super();

        this.state = {
            capacity: '',
            currCapacity: null,
            isSettingsOpen: false,
            isConfirmationOpen: false,
            isDelConfirmationOpen: false,
            userPassword: null,
            userCode: null
        }

        this.setCapacity = this.setCapacity.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.changeState = this.changeState.bind(this);
    }

    componentDidMount() {

        this.props.getCurrentDbCapacity();
        this.props.getAllScheduledSettings();
    }

    componentDidUpdate(prevProps) {

        if (prevProps.databaseData !== this.props.databaseData) {
            this.setState({
                ...this.state,
                currCapacity: this.props.databaseData.capacity
            });
        }
    }

    setCapacity({ target }) {

        this.setState({
            capacity: target.value
        });
    }

    toggleModal(modalType, settings) {

        this.setState({
            ...this.state,
            [`is${modalType}Open`]: !this.state[`is${modalType}Open`],
            editSettings: settings ? settings : null
        });
    }

    changeState({ target }) {

        this.setState({
            ...this.state,
            [target.name]: target.value
        });
    }

    renderPrePassContent() {
        return (
            <SettingsContentSection
                headingIcon={<MaterialIcon icon='autorenew' color='#0288d1' size={22} />}
                headingText={i18n.t('screens:systemControlContainer.databaseSettings')}
            >
                <PasswordVerificationScreen
                    password={this.state.userPassword}
                    onChange={this.changeState}
                    onSubmit={() => this.props.canUserAccessPosSettings(this.state.userPassword)}
                />
            </SettingsContentSection>
        );
    }

    renderPostPassContent() {

        return (
            <Fragment>
                <SettingsContentSection
                    headingIcon={<MaterialIcon icon='autorenew' color='#0288d1' size={22} />}
                    headingText={i18n.t('screens:systemControlContainer.scalingHeader')}
                >
                    <ScalingCapacityScreen
                        {...this.props}
                        state={this.state}
                        setCapacity={this.setCapacity}
                        onSubmit={() => this.toggleModal('Confirmation', null)}
                        styles={styles}
                    />
                </SettingsContentSection>

                <SettingsContentSection
                    headingIcon={<MaterialIcon icon='autorenew' color='#0288d1' size={22} />}
                    headingText={i18n.t('screens:systemControlContainer.scheduledSettings')}
                >
                    <ScheduledSettingsScreen
                        {...this.props}
                        state={this.state}
                        toggle={this.toggleModal}
                        styles={styles}
                    />
                </SettingsContentSection>
            </Fragment>
        );
    }

    renderModalContent() {
        const { canAccessPauseAllRestaurants } = this.props.user;
        const modalType = 'Confirmation', currSettings = null;

        if (this.state.isDelConfirmationOpen) {
            this.renderDelConfirmationModal();
        }

        const content = () => {
            return <Fragment>
                {
                    !canAccessPauseAllRestaurants ? null :
                        <span>
                            <MaterialIcon icon="warning" color="#ffc107" size={24} />
                        </span>
                }

                {!canAccessPauseAllRestaurants ? i18n.t('screens:restaurantsScreen.enterSecretCode') : i18n.t('screens:systemControlContainer.capacityWarning')}
                {!canAccessPauseAllRestaurants ? this.renderSecurityCodeField() : null}
            </Fragment>;
        }

        return <ModalContent
            onToggle={() => this.toggleModal(modalType, currSettings)}
            headerText={`${i18n.t('screens:systemControlContainer.scalingHeader')}?`}
            bodyContent={content()}
            onConfirm={() => this.requireSecurityCode()}
            onCancel={() => this.toggleModal(modalType, currSettings)} />;
    }

    renderDelConfirmationModal() {
        const modalType = 'DelConfirmation', currSettings = null;

        return <ModalContent
            onToggle={() => this.toggleModal(modalType, currSettings)}
            headerText={`${i18n.t('screens:systemControlContainer.deleteSettings')}?`}
            bodyContent={i18n.t('screens:systemControlContainer.delConfirmationMsg')}
            onConfirm={() => this.props.deleteScheduledSetting(
                this.state.editSettings.id,
                () => {
                    this.props.getAllScheduledSettings();
                    this.toggleModal(modalType, currSettings);
                }
            )}
            onCancel={() => this.toggleModal(modalType, currSettings)}
        />;
    }

    renderSecurityCodeField = () => {

        return (
            <AvForm onValidSubmit={() => this.props.canUserAccessPauseAllRestaurants(this.state.userCode)}>
                <AvGroup>
                    <span style={{ position: 'absolute', left: 25, top: 48 }}><MaterialIcon icon="lock" size={20} color="#a9a9a9" />
                    </span>
                    <AvField
                        style={{ paddingLeft: 36 }}
                        placeholder={i18n.t('screens:restaurantsScreen.secretCode')}
                        type="password" name="userCode" id="password"
                        value={this.state.userCode}
                        onChange={this.changeState}
                        required
                        errorMessage={i18n.t('common:validations.errorMsg')}
                    />
                </AvGroup>
            </AvForm>
        );
    }

    requireSecurityCode() {
        const { canAccessPauseAllRestaurants } = this.props.user;

        if (!canAccessPauseAllRestaurants) {
            this.props.canUserAccessPauseAllRestaurants(this.state.userCode);
            return;
        }

        this.props.setManualDbScaling(
            this.state.capacity,
            () => {
                this.props.getCurrentDbCapacity();
                /**
                 * Set manualy and not by 'toggleModal'
                 * because we need to reset more flags
                 * than that method does
                 */
                this.setState({
                    ...this.state,
                    isConfirmationOpen: false,
                    userCode: null,
                    settings: null,
                    userPassword: null
                });
                this.props.resetUserAccessPauseAllRestaurants();
            }
        );
    }

    render() {

        return (
            <Fragment>
                {
                    !this.props.user.canAccessPosSettings ? this.renderPrePassContent()
                        : this.renderPostPassContent()
                }
                {
                    this.state.isConfirmationOpen &&
                    <ConfirmationModal
                        isOpen={this.state.isConfirmationOpen}
                        onToggle={() => this.toggleModal('Confirmation', null)}>
                        {this.renderModalContent()}
                    </ConfirmationModal>
                }
                {
                    this.state.isDelConfirmationOpen &&
                    <ConfirmationModal
                        isOpen={this.state.isDelConfirmationOpen}
                        onToggle={() => this.toggleModal('DelConfirmation', null)}>
                        {this.renderDelConfirmationModal()}
                    </ConfirmationModal>
                }
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        databaseData: state.databaseData
    }
}

export default connect(mapStateToProps, {
    setManualDbScaling,
    getCurrentDbCapacity,
    getAllScheduledSettings,
    deleteScheduledSetting,
    createUpdateScheduledSetting,
    canUserAccessPosSettings,
    canUserAccessPauseAllRestaurants,
    resetUserAccessPauseAllRestaurants,
    dispatchErrorMessage
})(DatabaseContainer);

let styles = {
    containerStyle: {
        marginLeft: 0,
        marginBottom: 25,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        padding: 10
    },
    screenHeading: {
        display: 'flex',
        borderBottom: '1px solid rgb(222, 226, 230)',
        marginBottom: 20,
        marginLeft: 15,
        paddingLeft: 0,
        color: '#0288d1',
        width: 299
    },
    saveBtnStyles: {
        display: 'flex',
        alignSelf: 'flex-end',
        alignItems: 'center',
        marginBottom: 10
    }
};


// WEBPACK FOOTER //
// ./src/components/systemControl/database/DatabaseContainer.js